import { Grid } from '@salecycle/ui-component-library';
import * as React from 'react';
import { connect } from 'react-redux';

import { isInjectedChannel, TemplateChannel } from 'entities/campaign/rulesets/channels';
import { RulesetSplitTest, Variant } from 'entities/rulesetSplitTest';
import { Template } from 'entities/template';
import { Selectors as RouterSelectors } from 'router/';
import { Selectors as TemplateSelectors } from 'sections/assets/state/templates';
import { Selectors as RulesetSelectors } from 'sections/campaigns/state/rulesets';
import { Actions, Selectors } from 'sections/campaigns/state/rulesetSplitTests';
import { State } from 'store';
import { NewWizardSplitTestTemporaryId } from '../constants';
import VariantPanel from './variantPanel';

interface StateProps {
  defaultVariant: Variant;
  variants: Variant[];
  templates: Template[];
  splitTestId: string;
}

interface DispatchProps {
  updateSplitTest: (id: string, spliTest: RulesetSplitTest) => void;
}

export type Props = StateProps & DispatchProps;

const VariantChoicePage: React.FC<Props> = (props): JSX.Element => {
  const updateVariant = (index: number, updatedVariant: Variant): void => {
    const variants = [...props.variants];
    variants[index] = {
      ...variants[index],
      ...updatedVariant,
    };
    props.updateSplitTest(props.splitTestId, { variants });
  };

  return (
    <>
      <h2>Choose Templates</h2>
      <Grid>
        <VariantPanel isDefault={true} variant={props.defaultVariant} templates={props.templates} />
        {props.variants.map(
          (variant, index): JSX.Element => (
            <VariantPanel
              key={`${variant.name}-${index}`}
              index={index}
              variant={variant}
              templates={props.templates}
              updateVariant={updateVariant}
            />
          ),
        )}
      </Grid>
    </>
  );
};

export const mapStateToProps = (state: State): StateProps => {
  const rulesetSplitTestId = RouterSelectors.getSplitTestId(state) || NewWizardSplitTestTemporaryId;
  const splitTest = Selectors.getUpdatedEntity(state, rulesetSplitTestId);

  const percentageRemaining =
    100 -
    (splitTest.variants || [])
      .map((variant): number => variant.weight || 0)
      .reduce((acc, weight): number => acc + weight, 0);

  const ruleset = RulesetSelectors.getEntity(state, splitTest.rulesetId);
  const firstChannel = ruleset && (ruleset.channels[0] as TemplateChannel);

  let templateSelector;
  let templatePosition;
  if (isInjectedChannel(firstChannel)) {
    templateSelector = firstChannel.selector;
    templatePosition = firstChannel.templateInjectedPosition;
  }

  const defaultVariant: Variant = {
    name: 'Default',
    weight: percentageRemaining,
    templateId: ruleset && firstChannel.templateId,
    templateSelector: ruleset && templateSelector,
    templatePosition: ruleset && templatePosition,
    type: '.TemplateVariant',
  };

  return {
    defaultVariant,
    variants: splitTest.variants || [],
    templates: TemplateSelectors.getEntities(state),
    splitTestId: rulesetSplitTestId,
  };
};

const dispatchProps: DispatchProps = {
  updateSplitTest: Actions.updateLocal,
};

export default connect(mapStateToProps, dispatchProps)(VariantChoicePage);
